import authReducer from "./authReducer";
import userReducer from "./userReducer";
import postReducer from "./postReducer";
import { combineReducers } from "redux";// kết hợp các reducer thành một roorReducer duy nhất 
import storage from "redux-persist/lib/storage"; // Đây là đối tượng lưu trữ mà bạn sử dụng để xác định nơi lưu trữ trạng thái Redux (ví dụ: Local Storage, AsyncStorage).
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";  //hàm giải quyết xung đột giữa trạng thái mới và trạng thái đã lưu trữ. Nó được sử dụng để quyết định cách hợp nhất hai phiên bản trạng thái.
import { persistReducer } from "redux-persist";//  nó được sử dụng để bọc một reducer đã có để cấu hình lưu trữ bản cục cho reducer đó.
import appReducer from "./appReducer";

/* Cấu hình cho lưu trữ chung (commonConfig):
storage: Bạn xác định loại lưu trữ bạn muốn sử dụng (đã được import từ redux-persist).
stateReconciler: Bạn sử dụng autoMergeLevel2 để quản lý cách hợp nhất trạng thái.*/
const commonConfig = {
    storage,
    stateReconciler: autoMergeLevel2
}
/*Cấu hình cho lưu trữ cho auth (authConfig):
...commonConfig: Bạn sử dụng toàn bộ cấu hình chung từ commonConfig, bao gồm cả storage và stateReconciler.
key: Đây là khóa để xác định nơi lưu trữ trạng thái của reducer auth.
whitelist: Bạn chỉ định các thuộc tính của trạng thái mà bạn muốn lưu trữ. Trong trường hợp này, bạn chỉ muốn lưu trữ isLoggedIn và token từ trạng thái auth.*/
const authConfig = {
    ...commonConfig,
    key: 'auth',
    whitelist: ['isLoggedIn', 'token']
}
/*Combine reducers:
rootReducer được tạo bằng cách sử dụng combineReducers.
auth: Bạn sử dụng persistReducer để bọc reducer auth với cấu hình lưu trữ authConfig. Điều này sẽ quản lý việc lưu trữ và phục hồi trạng thái 
của reducer auth theo cách đã cấu hình.*/
const rootReducer = combineReducers({
    auth: persistReducer(authConfig, authReducer),
    user: userReducer,
    post: postReducer,
    app: appReducer
})

export default rootReducer